import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import { useNavigate } from 'react-router-dom';

import Link from '../components/Link';

const LinkContainer = ({
  disabled,
  onClick,
  to,
  target,
  className,
  rel,
  title,
  children,
  href,
  ...rest
}) => {
  const navigate = useNavigate();

  const onClickNavigate = useCallback(
    (e) => {
      e.preventDefault();

      if (disabled) return;
      if (onClick) onClick(e);
      if (target === '_blank') {
        window.open(to);
        return;
      }
      if (to) navigate(to);
    },
    [disabled, navigate, onClick, target, to],
  );

  return (
    <>
      {href ? (
        <a
          href={href}
          target={target}
          rel={rel}
          className={className}
          title={title}
          {...rest}>
          {children}
        </a>
      ) : (
        <Link
          onClick={onClickNavigate}
          href={to}
          className={className}
          target={target}
          disabled={disabled}
          rel={rel}
          title={title}
          {...rest}>
          {children}
        </Link>
      )}
    </>
  );
};

LinkContainer.propTypes = {
  disabled: PropTypes.bool,
  onClick: PropTypes.func,
  to: PropTypes.string,
  children: PropTypes.node,
  className: PropTypes.string,
  target: PropTypes.string,
  rel: PropTypes.string,
  href: PropTypes.string,
  title: PropTypes.string,
};

export default LinkContainer;
